import React from "react";
import { Navigate } from "react-router-dom";
import useTokenRefresher from "../../hooks/useTokenRefresher";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  useTokenRefresher();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { verifyToken } from "./methods";

// const ProtectedRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("authToken");

//     if (token) {
//       verifyToken(token)
//         .then((isValid) => {
//           setIsAuthenticated(isValid);
//         })
//         .catch(() => {
//           setIsAuthenticated(false);
//         });
//     } else {
//       setIsAuthenticated(false);
//     }
//   }, []);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;
